import { validateZipCodeModal } from '../utils/queries';
import { useQuery } from '@apollo/client';
import useZipcode from './useZipcode';
import React, { useCallback } from 'react';
import useDevice from '../../common/hooks/useDevice';
export default (function (_ref) {
  var showing = _ref.showing,
    handleHide = _ref.handleHide,
    setShowing = _ref.setShowing,
    _ref$withCity = _ref.withCity,
    withCity = _ref$withCity === void 0 ? false : _ref$withCity,
    Component = _ref.component,
    zipCodeLink = _ref.zipCodeLink;
  var location = useZipcode({
    withCity: withCity
  });
  var deviceData = useDevice();
  var _useQuery = useQuery(validateZipCodeModal, {
      ssr: true,
      skip: !showing
    }),
    data = _useQuery.data,
    loading = _useQuery.loading,
    error = _useQuery.error;
  var _ref2 = data || {},
    privacyPolicyUrl = _ref2.privacyPolicyUrl,
    valuesOutsideUsUrl = _ref2.valuesOutsideUsUrl;
  var valuesOutsideUsUrlCallback = useCallback(function (event) {
    event.preventDefault();
    if (valuesOutsideUsUrl) {
      window.open(valuesOutsideUsUrl, '_blank', '');
      return false;
    }
  }, [valuesOutsideUsUrl]);
  if (!showing || loading) {
    return null;
  }
  var onHide = function onHide() {
    handleHide ? handleHide() : setShowing(false);
    if (zipCodeLink) {
      zipCodeLink.focus();
    }
  };
  return React.createElement(Component, {
    showing: showing,
    handleHide: onHide,
    location: location,
    privacyPolicyUrl: privacyPolicyUrl,
    acceptGeoLocation: (deviceData === null || deviceData === void 0 ? void 0 : deviceData.istablet) || (deviceData === null || deviceData === void 0 ? void 0 : deviceData.issmartphone),
    valuesOutsideUsUrl: valuesOutsideUsUrlCallback
  });
});